// Dictionary, 852 part 1 — the 852-specific header body segment: BCT (852's
// beginning segment). Generic X12 852 (5010) definitions only; not tied to
// any trading partner's implementation guide.
//
// Everything else the 852 header body and its Name (N1) loop use — REF, PER,
// DTM, FOB, MSG, PWK, N1-N9, LM/LQ — is a segment X12 defines once and reuses
// across transaction sets, so it's already defined in
// dictionary/header-segments.ts and merged in by index.ts. This file does
// not redefine any of them.

import {LoopId, type ElementDefinition, type SegmentDefinition} from './types';

function el(
  position: number,
  label: string,
  description: string,
  extra: Partial<ElementDefinition> = {}
): ElementDefinition {
  return {position, label, description, ...extra};
}

export const HEADER_SEGMENTS_852: Record<string, SegmentDefinition> = {
  BCT: {
    id: 'BCT',
    name: 'Beginning Segment for Product Transfer and Resale Report',
    purpose:
      'Identifies the product activity/POS report itself — what kind of activity it reports, its own reference number and creation date/time. Required at the start of every 852.',
    loop: LoopId.Header,
    required: true,
    elements: [
      el(1, 'Report Type Code', 'What kind of activity this report contains.', {
        dataType: 'code',
        required: true,
        codes: [
          {code: 'AI', label: 'Inventory Activity'},
          {code: 'AS', label: 'Sales Activity'},
          {code: 'AC', label: 'Combined Sales and Inventory Activity'},
        ],
      }),
      el(
        2,
        'Application Type',
        'The reporting application area this report originates from.'
      ),
      el(
        3,
        'Reference Identification',
        "The report's own reference/control number.",
        {required: true}
      ),
      el(4, 'Date', 'Date this report was created.', {
        dataType: 'date',
        format: 'CCYYMMDD',
        required: true,
      }),
      el(5, 'Time', 'Time this report was created.', {dataType: 'time'}),
      el(
        6,
        'Transaction Type Code',
        'Whether this report replaces or supplements a previous one.',
        {
          dataType: 'code',
          codes: [
            {code: '00', label: 'Original'},
            {code: '01', label: 'Replace'},
          ],
        }
      ),
      el(
        7,
        'Action Code',
        'Whether this report adds, changes or deletes previously reported data.',
        {
          dataType: 'code',
          codes: [
            {code: 'A', label: 'Add'},
            {code: 'C', label: 'Change'},
            {code: 'D', label: 'Delete'},
          ],
        }
      ),
      el(
        8,
        'Reference Identification',
        'A related contract or agreement number, when applicable.'
      ),
    ],
  },
};
